<div class="row" *ngIf="accountCv">
    <div class="col-md-3">
        <div class="card">
            <div class="card-body">
                <div class="text-center">
                    <img [src]="accountCv.photo ? accountCv.photo : './assets/media/users/default.jpg'"
                         width="100px"
                         height="100px"
                         class="rounded-circle shadow"
                         style="border: 3px solid #fff;" />
                    <h4 class="mt-3">{{ accountCv.firstName + ' ' + accountCv.lastName }}</h4>
                    <h6 class="mt-2">{{ accountCv.email }}</h6>
                    <h6 class="mt-2">{{ accountCv.mobilePhone }}</h6>
                </div>
            </div>
        </div>
        <div class="card mt-2 mb-2">
            <div class="card-body text-center">
                <h6 class="mb-3">Profil Tamamlanma Oranı</h6>
                <ngb-progressbar [type]="progressColor"
                                 [value]="progressCompletedRatio"
                                 [max]="100"
                                 [showValue]="true"
                                 [striped]="true"></ngb-progressbar>
            </div>
        </div>
        <div class="card mt-2 mb-2">
            <div class="card-body text-center">
                <h6 class="mb-3">Bilgilerini Güncelle</h6>
                <ng-template [ngxPermissionsOnly]="[
                                    'UpdateEducationInformationFromYoksis',
                                    'UpdateIdentificationInformationFromMernis'
                                ]">
                    <div ngbDropdown class="d-inline-block">
                        <button class="btn btn-primary btn-sm" id="ddOperations" ngbDropdownToggle>
                            <i class="fa fa-ellipsis-v"></i> İşlemler
                        </button>
                        <div ngbDropdownMenu aria-labelledby="ddOperations">
                            <ng-template [ngxPermissionsOnly]="['UpdateEducationInformationFromYoksis']">
                                <button ngbDropdownItem (click)="updateEducationInformationFromYoksis()">
                                    <i class="fa fa-school fa-fw"></i> Eğitim Bilgilerini Yöksis'ten Güncelle
                                </button>
                            </ng-template>
                            <ng-template [ngxPermissionsOnly]="['UpdateIdentificationInformationFromMernis']">
                                <button ngbDropdownItem
                                        (click)="updateIdentificationInformationFromMernis()">
                                    <i class="fa fa-id-card fa-fw"></i> Kimlik Bilgilerini Mernis'ten Güncelle
                                </button>
                            </ng-template>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="col-md-9">
        <div class="card">
            <div class="card-body">
                <h3>Eğitim Bilgileri</h3>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead class="bg-secondary">
                            <tr>
                                <th>Okul Adı</th>
                                <th>Fakültesi/Yüksekokulu/Meslek Yüksekokulu</th>
                                <th>Bölüm/Program</th>
                                <th>Mezuniyet Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let educationInformation of accountCv.educationInformations">
                                <td>{{ educationInformation.universityName }}</td>
                                <td>{{ educationInformation.facultyName }}</td>
                                <td>{{ educationInformation.departmentName }}</td>
                                <td>{{ educationInformation.graduationDate | date: 'dd.MM.yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 class="mt-5">İş Deneyimi Bilgileri</h3>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead class="bg-secondary">
                            <tr>
                                <th>Kurum/Firma</th>
                                <th>Pozisyon/Unvan</th>
                                <th>Başlama Tarihi</th>
                                <th>Bitiş Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let workExperience of accountCv.workExperiences">
                                <td>{{ workExperience.employer }}</td>
                                <td>{{ workExperience.position }}</td>
                                <td>{{ workExperience.beginDate | date: 'dd.MM.yyyy' }}</td>
                                <td>
                                    {{
                                        workExperience.isContinued
                                            ? 'Devam Ediyor'
                                            : (workExperience.endDate | date: 'dd.MM.yyyy')
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 class="mt-5">Sertifika Bilgileri</h3>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead class="bg-secondary">
                            <tr>
                                <th>Kurum/Firma</th>
                                <th>Sertifika Adı</th>
                                <th>Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let certificateInformation of accountCv.certificateInformations">
                                <td>{{ certificateInformation.company }}</td>
                                <td>{{ certificateInformation.name }}</td>
                                <td>{{ certificateInformation.date | date: 'dd.MM.yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 class="mt-5">Staj Bilgileri</h3>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead class="bg-secondary">
                            <tr>
                                <th>Kurum/Firma</th>
                                <th>Başlama Tarihi</th>
                                <th>Bitiş Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let internshipInformation of accountCv.internshipInformations">
                                <td>{{ internshipInformation.company }}</td>
                                <td>{{ internshipInformation.beginDate | date: 'dd.MM.yyyy' }}</td>
                                <td>
                                    {{
                                        internshipInformation.isContinued
                                            ? 'Devam Ediyor'
                                            : (internshipInformation.endDate | date: 'dd.MM.yyyy')
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h3 class="mt-5">Yabancı Dil Bilgileri</h3>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                        <thead class="bg-secondary">
                            <tr>
                                <th>Öğrenildiği yer</th>
                                <th>Yabancı Dil</th>
                                <th>Okuma</th>
                                <th>Yazma</th>
                                <th>Konuşma</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let foreignLanguageInformation of accountCv.foreignLanguageInformations">
                                <td>{{ foreignLanguageInformation.learnedLocation }}</td>
                                <td>{{ foreignLanguageInformation.name }}</td>
                                <td><span class="text-warning">&#9733;</span>{{ foreignLanguageInformation.reading }}</td>
                                <td><span class="text-warning">&#9733;</span>{{ foreignLanguageInformation.writing }}</td>
                                <td><span class="text-warning">&#9733;</span>{{ foreignLanguageInformation.speaking }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<p-confirmDialog #cd header="Onay" icon="pi pi-exclamation-triangle" appendTo="body">
    <p-footer>
        <button class="btn btn-secondary mr-1" type="button" (click)="cd.reject()">
            <i class="fa fa-times"></i> Hayır
        </button>
        <button type="submit" class="btn btn-info" (click)="cd.accept()">
            <i class="fa fa-check"></i> Evet
        </button>
    </p-footer>
</p-confirmDialog>
